module.exports = __webpack_public_path__ + "static/media/r_dot_11.a329a61a.png";